
define('text!templates/widgets/dataGridCells/filters/textboxFilter.html',[],function () { return '<div class="search-container">\n    <i class="fa fa-search"></i>\n    <input type="text" class="form-control input-sm" data-bind="\n        value: value,\n        valueUpdate: &apos;keyup&apos;\n        ">\n</div>';});

